import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, Box, Stack, Dialog, DialogContent, FormControl, OutlinedInput, InputAdornment, FormControlLabel, Radio, RadioGroup, Avatar, TextField, } from "@mui/material";
import "../TaskAssignment/TaskAssignment.css";
import { farmers, images, taskAssign } from "../../config/images";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "./DataCollector.css";
import { useNavigate } from "react-router-dom";
import { getDataCollectorList, signup } from "../../config/services";
import translations from "../../config/language";
import SearchIcon from "@mui/icons-material/Search";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const DataCollector = () => {
  const [addCollectoer, setAddCollector] = useState(false);

  const [tasks, setTasks] = useState([]);
  const [formValues, setTaskData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    mobileNumber: "",
    gender: "",
    email: "",
    newPassword: "",
    confirmPassword: "",
  });

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Data Collectors" && module.is_editor === true
  ) ? true : false;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTaskData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return parseInt(params.get('page')) || 1;
  });
  const [perPage, setPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [createLoading, setCreateLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);
  const [searchText, setSearchText] = useState();
  const [debounceSearchText, setDebouncedSearchText] = useState();

  const handleSubmit = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!formValues.firstName) {
      notifyError(translations[language].pleaseEnterFirstName);
      return;
    }
    if (!formValues.middleName) {
      notifyError(translations[language].pleaseEnterMiddleName);
      return;
    }
    if (!formValues.lastName) {
      notifyError(translations[language].pleaseEnterLastName);
      return;
    }
    if (!formValues.gender) {
      notifyError(translations[language].pleaseSelectGender);
      return;
    }
    if (!formValues.mobileNumber) {
      notifyError(translations[language].pleaseEnterMobileNumber);
      return;
    }
    if (!formValues.email) {
      notifyError(translations[language].pleaseEnterEmail);
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formValues.email)) {
      notifyError(translations[language].pleaseEnterValidEmail);
      return;
    }
    if (!formValues.newPassword) {
      notifyError(translations[language].pleaseEnterPassword);
      return;
    }
    if (!formValues.confirmPassword) {
      notifyError(translations[language].pleaseReEnterPassword);
      return;
    }
    if (formValues.newPassword != formValues.confirmPassword) {
      notifyError(translations[language].passwordMismatch);
      return;
    }

    const formData = new FormData(); // ✅ Create FormData object

    formData.append("first_name", formValues.firstName);
    formData.append("middle_name", formValues.middleName);
    formData.append("last_name", formValues.lastName);
    formData.append("gender", formValues.gender === "male" ? 0 : 1);
    formData.append("role", 5);
    formData.append("mobile_number", `91${formValues.mobileNumber}`);
    formData.append("email", formValues.email);
    formData.append("password", formValues.password);

    try {
      setCreateLoading(true);

      const resp = await signup(formData);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setAddCollector(false);
        setTimeout(() => {
          setCreateLoading(false);
        }, 2000);
        fetchData();
      }
    } catch (error) {
      notifyError(error.response.data.message);
      setTimeout(() => {
        setCreateLoading(false);
      }, 2000);
    }
  };
  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));
  const navigate = useNavigate();
  const handleVisibilityClick = (id) => {
    navigate(`/collectors-list/collector-detail/${id}?page=${currentPage}`);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]); // Effect runs when searchText changes
  const fetchData = async () => {
    const data = {
      search: debounceSearchText,
    }
    try {
      setLoading(true);
      const resp = await getDataCollectorList({ data, currentPage, perPage });

      if (resp.data.results.success == true) {
        setTasks(resp.data.results.payload);

        // Calculate total pages
        setCount(resp.data.count);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, debounceSearchText]);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    const url = new URL(window.location.href);
    url.searchParams.set('page', newPage);
    window.history.pushState({}, '', url);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get('page')) || 1;
    setCurrentPage(page);
  }, [window.location.search]);

  const handleTogglePasswordVisibility = (name) => {
    if (name === "newPassword") {
      setShowPassword((prevShowPassword) => !prevShowPassword);
    } else if (name === "confirmPassword") {
      setShowConfirmPassword(
        (prevShowConfirmPassword) => !prevShowConfirmPassword
      );
    }
  };

  const language = process.env.REACT_APP_LANGUAGE;


  return (
    <>
      {/* <Grid container spacing={2}>
        <Grid item xs={12}> */}
      <Box className="task-assign-box">
        <Box
          className="d-flex justify-content-between align-items-center"
          style={{ flexWrap: "wrap" }}
        >
          <Box
            className="d-flex  gap-3 img-box"
            style={{ padding: "25px" }}
          >
            <img src={taskAssign.collector} alt="" />
            <Typography variant="h6" gutterBottom>
              {translations[language].dataCollectors}
            </Typography>
          </Box>
          <Box className="collector-btn">
            <button
              className="assign-task-btn"
              onClick={() => {
                if (!isAccess) {
                  notifyError(translations[language].youDontHaveAccess);
                  return true;
                }
                setAddCollector(true)
              }
              }
            >
              {translations[language].addCollector}
            </button>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "0px 20px",
            boxShadow: "0px 4px 10px rgba(151, 151, 151, 0.12)",
          }}
          className="mt-3 mb-4"
        >
          <TextField
            placeholder="Search here"
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "400",
                    backgroundColor: "#31A05F",
                    height: "100%",
                    padding: "0px",
                    maxHeight: "unset",
                    padding: "0px 15px",
                  }}
                >
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  Search
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box className="crop-table-container">
          <Table className="region-table" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>{translations[language].srNo}</TableCell>
                <TableCell>{translations[language].photo}</TableCell>
                <TableCell>{translations[language].name}</TableCell>
                <TableCell>{translations[language].gender}</TableCell>
                <TableCell>{translations[language].mobileNumber}</TableCell>
                <TableCell>{translations[language].email}</TableCell>

                <TableCell>{translations[language].statusView}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks?.length > 0 ? tasks.map((task, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell style={{ textAlign: "center" }}>
                      {index + 1 + (currentPage - 1) * perPage}
                    </TableCell>
                    <TableCell>
                      {" "}
                      <Avatar
                        src={task.profile_photo}
                        className="farmer-photo"
                      />
                    </TableCell>
                    <TableCell>
                      {task.first_name} {task.middle_name} {task.last_name}
                    </TableCell>
                    <TableCell>
                      {task.gender == 0 ? "Male" : "Female"}
                    </TableCell>
                    <TableCell>{task.mobile_number}</TableCell>

                    <TableCell>{task.email}</TableCell>
                    <TableCell>
                      <div className="d-flex gap-4">
                        <div
                          style={{
                            width: "50px",
                            color: task.is_active == true ? "#31A05F" : "",
                          }}
                        >
                          {task.is_active == true ? translations[language].active : translations[language].inactive}
                        </div>
                        <VisibilityIcon
                          onClick={() => handleVisibilityClick(task.id)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                )
              }) : <TableRow>
                <TableCell colSpan={7} style={{ textAlign: "center" }}>
                  <img src={farmers.noData} alt="No Data" />
                </TableCell>
              </TableRow>}
            </TableBody>
          </Table>
        </Box>
        <Box display="flex" justifyContent="end" alignItems="center" className="pagination">
          <Stack spacing={2} className="mb-3">
            <CustomPagination
              count={Math.ceil(count / perPage)}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
          </Stack>
        </Box>
        <Dialog
          open={addCollectoer}
          // onClose={() => setAddCollector(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5
                className="p-3 mb-0"
                style={{ textAlign: "center", marginLeft: "100px" }}
              >
                {translations[language].addCollector}
              </h5>
              <img
                src={taskAssign.closeIcon}
                alt=""
                style={{
                  height: "30px",
                  width: "30px",
                  cursor: "pointer",
                  marginLeft: "65px",
                }}
                className="close-btn-model"
                onClick={() => setAddCollector(false)}
              />
            </div>
          </div>
          <DialogContent>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput
                value={formValues.firstName}
                autoComplete="off"
                onChange={(e) => {
                  const inputValue = e.target.value;
                  // Allow only letters and limit to 50 characters
                  if (/^[A-Za-z\s]{0,50}$/.test(inputValue)) {
                    handleChange(e);
                  }
                }}
                name="firstName"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.mobileNumberIcon}
                      alt="mobile-icon"
                      className="input-logo"
                    />
                  </InputAdornment>
                }
                placeholder={translations[language].firstName}
              />
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput
                value={formValues.middleName}
                autoComplete="off"
                onChange={(e) => {
                  const inputValue = e.target.value;
                  // Allow only letters and limit to 50 characters
                  if (/^[A-Za-z\s]{0,50}$/.test(inputValue)) {
                    handleChange(e);
                  }
                }}
                name="middleName"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.mobileNumberIcon}
                      alt="mobile-icon"
                      className="input-logo"
                    />
                  </InputAdornment>
                }
                placeholder={translations[language].middleName}
              />
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput
                value={formValues.lastName}
                autoComplete="off"
                onChange={(e) => {
                  const inputValue = e.target.value;
                  // Allow only letters and limit to 50 characters
                  if (/^[A-Za-z\s]{0,50}$/.test(inputValue)) {
                    handleChange(e);
                  }
                }}
                name="lastName"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.mobileNumberIcon}
                      alt="mobile-icon"
                      className="input-logo"
                    />
                  </InputAdornment>
                }
                placeholder={translations[language].lastName}
              />
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }}>
              <RadioGroup
                row
                className="login-type"
                name="gender"
                value={formValues.gender}
                onChange={handleChange}
              >
                <div className="singIn-option-div">
                  <FormControlLabel
                    value="male"
                    control={<Radio />}
                    label={translations[language].male}
                  />
                </div>
                <div className="singIn-option-div">
                  <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label={translations[language].female}
                  />
                </div>
              </RadioGroup>
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput
                value={formValues.mobileNumber}
                autoComplete="off"
                onChange={handleChange}
                name="mobileNumber"
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                inputProps={{
                  maxLength: 10,
                  pattern: "[0-9]*",
                  inputMode: "numeric",
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.mobileIcon}
                      alt="mobile-icon"
                      className="input-logo"
                    />
                  </InputAdornment>
                }
                placeholder={translations[language].mobileNumber}
              />
            </FormControl>
            <FormControl
              fullWidth
              sx={{ m: 1 }}
            >
              <OutlinedInput
                value={formValues.email}
                onChange={handleChange}
                autoComplete="off"
                name="email"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.emailIcon}
                      alt="email-icon"
                      className="input-logo"
                    />
                  </InputAdornment>
                }
                placeholder={translations[language].email}
              />
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }} variant="outlined">
              <OutlinedInput
                id="outlined-adornment-password"
                type={showPassword ? "text" : "password"}
                value={formValues.newPassword}
                autoComplete="off"
                onChange={handleChange}
                name="newPassword"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.viewPassword}
                      className="input-logo"
                      alt=""
                    ></img>
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.viewIcon}
                      onClick={() =>
                        handleTogglePasswordVisibility("newPassword")
                      }
                      className="input-logo"
                      style={{ cursor: "pointer" }}
                    ></img>
                  </InputAdornment>
                }
                placeholder={translations[language].enterPassword}
              />
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }} variant="outlined">
              <OutlinedInput
                id="outlined-adornment-password"
                type={showconfirmPassword ? "text" : "password"}
                value={formValues.confirmPassword}
                autoComplete="off"
                onChange={handleChange}
                name="confirmPassword"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.viewPassword}
                      className="input-logo"
                      alt=""
                    ></img>
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="start">
                    <img
                      src={images.viewIcon}
                      onClick={() =>
                        handleTogglePasswordVisibility("confirmPassword")
                      }
                      className="input-logo"
                      style={{ cursor: "pointer" }}
                    ></img>
                  </InputAdornment>
                }
                placeholder={translations[language].rePassword}
              />
            </FormControl>

            <button
              className="assign-task-button mt-2"
              onClick={handleSubmit}
              disabled={createLoading}
            >
              {createLoading ? (
                <span className="spinner"></span>
              ) : (
                translations[language].addCollector
              )}
            </button>
          </DialogContent>
        </Dialog>
      </Box>
      {/* </Grid>
      </Grid> */}
    </>
  );
};

export default DataCollector;
